<template>
  <div v-if="ready">
    <SignUpV2 v-show="step === 'SIGN_UP'" @completed="onSignUpComplete" />

    <!-- <b-row v-if="step === 'SURVEY'" class="justify-content-center">
      <b-col lg="3">
        <div class="h3 font-weight-bold mb-u4">Complete your profile</div>

        <b-alert variant="info" show class="mb-u4">
          Complete the following survey to sign up
        </b-alert>

        <FormProfileBasicInfo
          :show="showProfileProp"
          :data="profilePayload"
          @completed="onProfileCompleted"
        >
          <template v-slot:afterForm="props">
            <!~~ Complete button ~~>
            <b-button
              variant="first"
              style="width: 100%"
              class="mt-u12"
              @click="props.save(true)"
            >
              Complete
            </b-button>

            <!~~ Skip ~~>
            <div class="mt-u6">
              Not now?
              <b-button variant="link" @click="props.save(false)">
                Skip
              </b-button>
            </div>
          </template>
        </FormProfileBasicInfo>
      </b-col>
    </b-row>   -->

    <ModalPolicy
      :show="step === 'PDPA'"
      cancelable
      force-require-all
      @completed="onPdpaComplete"
      @canceled="onPdpaCanceled"
    />

    <VueElementLoading :active="isLoading" is-full-screen :text="loadingMessage" />
  </div>
</template>

<script>
import SignUpV2 from './SignUpV2.vue';
// import FormProfileBasicInfo from "@/views/Profile/components/FormProfileBasicInfo.vue";
import ModalPolicy from '@/views/PDPA/components/ModalPolicy.vue';
import User from '@/models/User';
import { CatalogConsent } from '@/models/catalog/CatalogConsent';
import { useAuth } from '@/composables';
import { notificationMixin } from '@/mixins';

const { login } = useAuth();

export default {
  components: {
    SignUpV2,
    // FormProfileBasicInfo,
    ModalPolicy
  },
  mixins: [notificationMixin],

  data() {
    return {
      step: parseInt(this.$route.query.step) || 'SIGN_UP', // step of sign up: SIGN_UP -> SURVEY (skip for now) -> PDPA
      showProfileProp: {
        name: true,
        surname: true,
        dateOfBirth: true,
        phoneNumber: true,
        currentOccupation: true,
        desiredOccupation: true,
        areaOfEmployment: true,
        experienceLevel: true,
        educationLevel: true,
        goals: true,
        likeToLearn: true,
        knowUsFrom: true,
        interests: true
      },
      profilePayload: {},
      pdpaPayload: null,
      isLoading: false,
      loadingMessage: '',
      ready: false
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler: 'onRouteChange'
    }
  },

  methods: {
    onRouteChange() {
      let authUser = User.query().first();

      if (authUser) {
        return this.$router.push({ path: '/' });
      }

      this.ready = true;
    },

    onSignUpComplete(payload) {
      this.profilePayload = { ...payload };
      this.step = 'PDPA';
    },

    // async onProfileCompleted(payload) {
    //   this.profilePayload = { ...this.profilePayload, ...payload };

    //   this.step = "PDPA";
    // },

    async onPdpaComplete(payload) {
      this.pdpaPayload = payload;

      await this.confirm();
    },

    onPdpaCanceled() {
      this.step = 'SIGN_UP';
    },

    async confirm() {
      this.isLoading = true;
      try {
        this.loadingMessage = 'Registering user, please wait...';

        await User.api().register(this.profilePayload);

        await login(this.profilePayload.email, this.profilePayload.password);

        const pdpa = await CatalogConsent.api().submitConsents(this.pdpaPayload);

        console.log('PDAP: ', pdpa);

        this.$router.push('send-verify-email');
      } catch (error) {
        console.error(error);
        this.notiErrorDefault('Something went wrong.');
      }
      this.isLoading = false;
    }
  }
};
</script>

<style></style>
